
import { Component, OnInit, Inject, forwardRef } from '@angular/core';
import { AppComponent } from '../app.component';

@Component({
  selector: 'inner-jacket',
  templateUrl: './inner-jacket.component.html',
  styleUrls: ['./inner-jacket.component.css']
})
export class InnerJacketComponent implements OnInit {

   constructor(@Inject(forwardRef(() => AppComponent)) public parent : AppComponent) {
   }
  
  ngOnInit() {
    this.parent.applyDesignOnJacket();
    console.log('this.parent.config.customisationDefaults.inner : ', this.parent.config.customisationDefaults.inner)
    console.log('this.parent.config.customisationDefaults.inner.innerDesignSelected : ', this.parent.config.customisationDefaults.inner.innerDesignSelected)
  }

}


// WEBPACK FOOTER //
// /Users/jaswantdhayal/Desktop/Projects/seniorJackets/src/app/inner-jacket/inner-jacket.component.ts